import { ListGroupBy } from '../common/list-group-by';
import { ListItem } from '../common/list-item';
import * as moment from 'moment';
import { ListSortBy } from '../common/list-sort-by';
import { FORMAT } from '@core/utils/formats';

/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

export class BillingInvoice implements ListItem {
    public id: string;
    public owner_id: string;
    public desc: string;
    public date: string;
    public download_options: {
        mime_type: string,
        new_window: boolean,
        path: string,
        title: string
    }[];
    public status: string;
    public start_balance: number;
    public end_balance: number;
    public subtotal: number;
    public total: number;
    public receipt_number: string; // need to confirm
    public attempt_count: number;
    public period_start: string;
    public period_end: string;
    public next_payment_attempt: string; // need to confirm
    public line_items: any[];
    public loading: boolean = false;
    public selected: boolean;

    /**
     * Validates if this item matches the selected groups.
     * @param groupBy
     * @param selectedGroups
     * @returns {boolean}
     */
    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        return true;
    }

    /**
     * Validates the kiosk matches the filter.
     * @param filterBy
     * @param filterValue
     * @returns {boolean}
     */
    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        return true;
    }

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        return '';
    }

    /**
     * Custom valueOf allows for param based sort / comparision
     * @param ref
     * @returns {any}
     */
    valueOf(ref?: any): any {
        let res: any = this;
        if (ref === ListSortBy.TIME) {
            res = moment(this.date, FORMAT.DATE_SHORT);
        }

        return res;
    }

    get historyDate(): string {
        return moment(this.date, FORMAT.DATE_SHORT).format(
            FORMAT.DATETIME_LONG
        );
    }
}
